export default __webpack_public_path__ + "static/media/logo-fo.731f9fc1.png";